<template>
  <div class="cart__item">
    <!-- type:1未有效的否则无效的商品 -->
    <div v-if="type == 1" class="item__full">
      <span @click="changeStatus(list)">
        <img
          class="item__full_check"
          :src="list.selected?'https://static.zc0901.com/imola-dci-product-full.png':'https://static.zc0901.com/imola-dci-product-empty.png'"
        />
      </span>
      <img :src="list.image" class="pic" />
      <div class="item__full__desc">
        <div>{{list.title}}</div>
        <div>{{list.desc}}</div>
      </div>
      <div class="item__full__money text-left">¥ {{list.price}}</div>
      <div class="item__full__number text-center">
        <div>{{list.area}}平米</div>
        <div class="mt1">
          <el-input
            placeholder="请输入内容"
            v-model="list.number"
            @input="(e)=>changeNumber(e,list)"
            @change="((currentValue)=>{changeNum(currentValue, list)})"
          >
            <el-button slot="prepend" icon="el-icon-minus" @click="minus(list)"></el-button>
            <el-button slot="append" icon="el-icon-plus" @click="add(list)"></el-button>
          </el-input>
        </div>
        <p
          class="h5 text-red item__full__number_stock"
          v-if="list.isInventory"
        >库存不足{{list.stock+1}}件</p>
      </div>
      <div class="item__full__needMoney text-left">¥{{list.sumPrice}}</div>
      <div class="item__full__delete" @click="deleteFn(list)">删除</div>
    </div>
    <!-- 下架的商品 -->
    <div v-else class="item__air">
      <div class="item__air__top">
        <div class="item__air__top__tip">下架</div>
        <img :src="list.image" />
        <div class="item__air__top__desc">
          <div>{{list.title}}</div>
          <div>{{list.desc}}</div>
        </div>
        <div class="item__full__money text-left">¥ {{list.price}}</div>
        <div class="item__full__number text-center">
          <div>
            <el-input-number :min="list.number" :max="list.number" v-model="list.number"></el-input-number>
          </div>
        </div>
        <div class="item__full__needMoney text-left">¥{{list.sumPrice}}</div>
        <div class="item__full__delete" @click="deleteFn(list)">删除</div>
        <div class="item__air_other" @click="changeSeries(list)">
          <span class="h5">选择其他系列</span>
          <span class="imgWith" :class="list.show?'item__air_other_up':'item__air_other_down'"></span>
        </div>
      </div>
      <div class="item__air__bottom" v-if="list.show">
        <div>
          <div class="cart__list">
            <div class="cart__list__item" v-for="(item,index) in seriesList" :key="index" @click="$router.push({path:`/seriesDetail`,query:{id:item.id}})">
              <img class="cart__list__item__cover" :src="item.image" />
              <div class="cart__list__item__price">¥{{item.minPrice}}-{{item.maxPrice}}</div>
              <div class="cart__list__item__content">
                <div class="cart__list__item__content__title">
                  <img src="https://static.zc0901.com/dci-web-cart-list-img.png" />
                  <div>{{item.title}}</div>
                </div>
                <div class="cart__list__item__content__desc" :title="item.content">{{item.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "./index.scss";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  props: ["type", "list",'seriesList'],
  data() {
    return {
      choseItem: 1
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    //改变购物车的选中状态
    changeStatus(item) {
      this.$emit("changeCartSelect", item);
    },
    //购物车数量更改
    changeNumber(e, list) {
      this.$emit('inputChange',e,list)      
    },
    changeNum(currentValue, list) {
      this.$emit("changeNumber", currentValue, list);
    },
    //购物车减
    minus(list) {
      this.$emit("minus", list);
    },
    //购物车加
    add(list) {
      this.$emit("add", list);
    },
    //失效商品查看其他系列
    changeSeries(list) {
      this.$emit("seriesSearch", list);
    },
    //单个删除购物车的产品
    deleteFn(shop) {
      this.$emit("onDeleteFn", shop);
    }
  }
};
</script>
<style lang="scss" scoped>
.cart__item:nth-child(2n + 1) {
  background: rgba(241, 241, 241, 1);
}
.item__air {
  position: relative;
  .item__air_other {
    position: absolute;
    display: flex;
    align-items: center;
    right: 30px;
    top: 88px;
    cursor: pointer;
    .imgWith {
      display: inline-block;
      width: 24px;
      height: 24px;
      background-size: cover;
    }
    &_up {
      background-image: url("../../../assets/images/arrowup.png");
    }
    &_down {
      background-image: url("../../../assets/images/arrowdown.png");
    }
  }
  &__bottom {
    padding: 20px 0;
    background: rgba(241, 241, 241, 1);
  }
}
</style>
<style lang="scss">
.item__full__number {
  .el-input-group {
    width: 95px;
    height: 24px;
    display: flex;
    align-items: center;
    margin: auto;
    i {
      color: #8b2a2a;
      font-weight: bold;
    }
    .el-input-group__append,
    .el-input-group__prepend {
      width: 24px;
      height: 24px;
      padding: 0;
      border: none;
      background: none;
      .el-button {
        width: 22px;
        height: 22px;
        padding: 0;
      }
    }
    .el-input__inner {
      width: 39px;
      height: 24px;
      margin: 0 4px;
      padding: 0;
      text-align: center;
      border: none;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.1);
    }
  }
}
.item__air {
  .el-input-number {
    width: 95px;
    height: 24px;
    display: flex;
    align-items: center;
    margin: auto;
  }
  .el-input-number__decrease {
    width: 24px;
    height: 24px;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
  .el-input-number__increase {
    width: 24px;
    height: 24px;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
  .el-input-number .el-input {
    width: 39px;
    height: 24px;
    background: rgba(241, 241, 241, 1);
    border-radius: 4px;
    margin: 0 28px 0 28px;
  }
  .el-input-number .el-input__inner {
    padding: 0;
    border: none;
    width: 39px;
    height: 24px;
    background: rgba(241, 241, 241, 1);
    border-radius: 4px;
  }
  .numDisabled {
    .el-input.is-disabled {
      .el-input__inner {
        background-color: #f1f1f1;
      }
    }
  }
}
</style>
